import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CertificateListService, NotificationService, ShareType } from '@core';

@Component({
    selector: 'app-share-history',
    templateUrl: './share-history.component.html',
    styleUrls: ['./share-history.component.less'],
    standalone: false
})
export class ShareHistoryComponent implements OnInit {
  sharedHistory: any[] = [];

  isloading: boolean = false;

  //PAGINATION
  current_page: number = 0;
  total: number = 0;
  from: number = 0;
  to: number = 0;
  lastpage: number = 0;
  pageSize: number = 0;
  pageCount: number = 0;
  page: any[] = [];
  meta: any;
  nextPage: string = "";
  paginator = 0;

  shareType = ShareType;


  constructor(
    private certificateService: CertificateListService,
    private notify: NotificationService,
    private location: LocationStrategy
  ) { }

  ngOnInit(): void {
    this.loadSharedlogs();
    this.isloading = true;    
  }


  next(id: number): void {
    if (this.nextPage) return;
    this.isloading = true;
    let page_size = 10;
    let url = `?page=${id}&page_size=${page_size}`;

    this.certificateService
      .sharedCertificate(url)
      .then((res) => {
        if (res.error) {
          this.notify.error("", res.error);
          this.isloading = false;
          return;
        }
        this.sharedHistory = res?.data?.data;
          const {
            current_page,
            last_page,
            total,
            per_page,
            count,
          } = res?.data?.pagination;
          this.current_page = current_page;
          this.pageCount = count;
          this.lastpage = last_page;
          this.from = current_page * per_page - per_page + 1;
          this.to = (current_page - 1) * per_page + count;
          this.pageSize = per_page;
          this.total = total;
          this.isloading = false;

      })
      .catch(() => {
        this.isloading = false;
        //this.notify.error("", err);
      });
  }

  loadSharedlogs(): void {
    this.isloading = true;
    let page_size = 10;
    let url = `?page=1&page_size=${page_size}`;
    this.certificateService
      .sharedCertificate(url)
      .then((res) => {
        this.sharedHistory = res?.data?.data;
        const {
            current_page,
            last_page,
            total,
            per_page,
            count,
          } = res?.data?.pagination;
          this.current_page = current_page;
          this.pageCount = count;
          this.lastpage = last_page;
          this.from = current_page;
          this.to = (current_page - 1) * per_page + count;
          this.pageSize = per_page;
          this.total = total;
          this.isloading = false;
      })
      .catch(() => {
        // this.notify.error("", err);
        this.isloading = false;
      });
  } 

  onReturnToPreviousPage() {
    this.location.back();
  }

}
